export const connectorUtils = {
  getIconSrc(connectorType: string): string | null {
    switch (connectorType) {
      case 'TYPE_TWO':
        return '/assets/svg/connectors/connector-plug-type-two.svg'
      case 'CCS_TYPE_TWO':
        return '/assets/svg/connectors/connector-plug-ccs-type-two.svg'
      case 'TESLA':
        return '/assets/svg/connectors/connector-plug-tesla.svg'
      case 'CHADEMO':
        return '/assets/svg/connectors/connector-plug-chademo.svg'
      default:
        return null
    }
  },

  hasIcon(connectorType: string): boolean {
    return connectorUtils.getIconSrc(connectorType) !== null
  },

  getLabel(connectorType: string): string {
    switch (connectorType) {
      case 'TYPE_TWO':
        return 'Tipo 2'
      case 'CCS_TYPE_TWO':
        return 'CCS Tipo 2'
      case 'TESLA':
        return 'Tesla'
      case 'CHADEMO':
        return 'CHAdeMO'
      default:
        return 'Conector não identificado'
    }
  },
}
